
import { SignIn } from "@/components/auth/SignIn";
import { SignUp } from "@/components/auth/SignUp";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";
import { supabase } from "@/integrations/supabase/client";

const Auth = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  
  // Déterminer l'onglet par défaut en fonction de l'état de location
  const defaultTab = location.state?.defaultTab || "signin";
  
  useEffect(() => {
    console.log("Auth component mounted");
    console.log("Auth state:", location.state);
    console.log("Default tab:", defaultTab);
    
    if (isAuthenticated) {
      console.log("User is authenticated, redirecting to home");
      navigate("/");
      return;
    }

    // Check for OAuth redirect response
    const checkOAuthResponse = async () => {
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const queryParams = new URLSearchParams(window.location.search);
      
      // Log relevant authentication info for debugging
      console.log("Hash parameters:", window.location.hash);
      console.log("Query parameters:", window.location.search);
      
      const hasOAuthParams = hashParams.has("access_token") || 
                             queryParams.has("code") || 
                             queryParams.has("error");

      if (hasOAuthParams) {
        console.log("OAuth redirect detected, processing...");
        
        try {
          const { data, error } = await supabase.auth.getSession();
          
          if (error) {
            console.error("Error getting session after OAuth redirect:", error);
          } else if (data.session) {
            console.log("OAuth sign-in successful, redirecting to home");
            navigate("/");
          }
        } catch (err) {
          console.error("Error processing OAuth response:", err);
        }
      }
    };
    
    checkOAuthResponse();
  }, [isAuthenticated, navigate, location.state, defaultTab]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-background to-muted/50 p-4">
      <div className="w-full max-w-md space-y-8">
        <Tabs defaultValue={defaultTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="signin">Connexion</TabsTrigger>
            <TabsTrigger value="signup">Inscription</TabsTrigger>
          </TabsList>
          <TabsContent value="signin">
            <SignIn />
          </TabsContent>
          <TabsContent value="signup">
            <SignUp />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Auth;
